import script from "./InterBox.vue?vue&type=script&setup=true&lang=js"
export * from "./InterBox.vue?vue&type=script&setup=true&lang=js"

import "./InterBox.vue?vue&type=style&index=0&id=470b4da3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-470b4da3"]])

export default __exports__